import Grid from '@mui/material/Grid';
import { observer } from 'mobx-react-lite';
import { HintBox, SelectField, TextField, Widget } from '../../../components';
import type { HelpItem } from '../../../components/form/HintBox';
import { AccountServicesHelp } from '../../../store/constants/help';
import type Account from '../store/Account';
import type { ServiceProvider } from '../store/services/types';
import type Webhooks from '../store/services/webhooks/Webhooks';
import OrderEmailTemplate from './OrderEmailTemplate';
import ShopifyForm from './ShopifyForm';
import SquarespaceForm from './SquarespaceForm';
import WixForm from './WixForm';

const SERVICES = [
  {
    value: '',
    label: <i>No service selected</i>,
    disabled: true,
  },
  {
    value: 'shopify',
    label: 'Shopify',
  },
  {
    value: 'squarespace',
    label: 'Squarespace',
  },
  {
    value: 'wix',
    label: 'Wix',
  },
];

export default observer(function ECommerceWidget({
  account,
}: {
  account: Account;
}) {
  const { configurations } = account;
  const { webhooks } = configurations;
  const provider = webhooks.selectedProvider;

  const help = (
    AccountServicesHelp.services as Record<string, HelpItem | undefined>
  )[provider || 'webhook'];

  return (
    <Widget sx={{ mt: 2 }} title="E-commerce platform">
      <Grid container spacing={6}>
        <Grid item xs={8}>
          <SelectField
            displayEmpty
            label="Service"
            onChange={(e) =>
              webhooks.setSelectedProvider(e.target.value as any)
            }
            options={SERVICES}
            required
            sx={{ mt: 2, width: 256 }}
            value={provider || ''}
          />
          <WebhooksForm provider={provider} webhooks={webhooks} />
        </Grid>
        <Grid item xs={4}>
          <HintBox help={help} />
        </Grid>
      </Grid>

      <OrderEmailTemplate configurations={configurations} />

      <TextField
        label="Notify when less than N serials left"
        name="lowSerialThreshold"
        onChange={configurations.handleChangeAndSave}
        required
        sx={{ mt: 4, width: 200 }}
        type="number"
        value={configurations.lowSerialThreshold}
      />
    </Widget>
  );
});

const WebhooksForm = observer(function WebhooksForm({
  webhooks,
  provider,
}: {
  provider?: ServiceProvider;
  webhooks: Webhooks;
}) {
  switch (provider) {
    case 'shopify': {
      return <ShopifyForm webhooks={webhooks} />;
    }
    case 'squarespace': {
      return <SquarespaceForm webhooks={webhooks} />;
    }
    case 'wix': {
      return <WixForm webhooks={webhooks} />;
    }
    default: {
      return null;
    }
  }
});
